// extracted by mini-css-extract-plugin
export default {"table":"style_table__p7GUb","disabled":"style_disabled__QJVLZ","courseTable":"style_courseTable__FRzRk","buttons":"style_buttons__vilXT","tableHeader":"style_tableHeader__O-WwG"};